import { z } from 'zod'

export const step1Schema = z.object({
  first_name: z.string().min(1, 'onboarding.errors.first_name_required').max(100),
  last_name: z.string().min(1, 'onboarding.errors.last_name_required').max(100),
  date_of_birth: z
    .string()
    .min(1, 'onboarding.errors.date_required')
    .refine((val) => new Date(val) < new Date(), {
      message: 'onboarding.errors.date_past',
    }),
  language: z.enum(['fr', 'en', 'ar', 'es'], { error: 'onboarding.errors.language_invalid' }),
})

export const step2Schema = z.object({
  persona_name: z.string().min(2, 'onboarding.errors.persona_name_min').max(100),
  tone: z.enum(['encouraging', 'strict', 'playful', 'neutral'], { error: 'onboarding.errors.tone_required' }),
  pedagogy_style: z.enum(['socratic', 'direct', 'collaborative', 'adaptive'], { error: 'onboarding.errors.style_required' }),
  description: z.string().max(500, 'onboarding.errors.description_max').optional(),
})

export const step3Schema = z.object({})

export type Step1FormData = z.infer<typeof step1Schema>
export type Step2FormData = z.infer<typeof step2Schema>
export type Step3FormData = z.infer<typeof step3Schema>

export type ToneType = Step2FormData['tone']
export type PedagogyStyleType = Step2FormData['pedagogy_style']

export interface OnboardingStatus {
  step: number
  completed: boolean
}
